import styled from '@emotion/styled'
import { Box } from '@mui/material'

import { CTAButtonWithWT } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

export const ButtonSection = () => {
  const { state } = useHouseDetail()

  const isDisabled = !state.active

  return (
    <ButtonSectionContainer>
      <CTAButtonWithWT
        disabled={isDisabled}
        style={{ width: '100%' }}
        wtPayload={{
          category: 'CTA-button',
          action: 'click',
          label: 'primary-CTA',
          indicates: ['funnel-entry'],
          location: 'sticky-summary',
          values: [{ type: 'text', value: 'Preisdetails kostenlos anfordern' }]
        }}
        variant='contained'
        color='secondary'
        data-request-type='house-detail-form'
        data-funnel-variant='house-wizard-item-priceinfo'
        data-sel='btn-cta-hdp-main'
        {...(state.vendor_nid && { 'data-vendor-nid': state.vendor_nid })}
        className='js-request-button'>
        {t('houseDetailPage.fixedCTA')}
      </CTAButtonWithWT>
    </ButtonSectionContainer>
  )
}

const ButtonSectionContainer = styled(Box)`
  grid-area: sidebar-button;
  margin: ${({ theme }) => theme.spacing(2)} 0;
  label: SidebarButtonContainer;
`
